import React from 'react'
import './Footer.css'
function Footer() {
    return (
        <div className="footer p-4">
            <p className="text-center text-white"> copyright &copy; All Right Reseved by online shop</p>
        </div>
    )
}

export default Footer
